"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCommandJobPayload = exports.UpsertCommandJobPayload = exports.CommandJobToggleResult = exports.CommandJobItem = exports.CommandJobProgressPage = exports.CommandJobProgress = exports.CommandJobPage = exports.CommandJob = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../../json"));
const Job = __importStar(require("../../../../../job"));
const openapi_1 = require("../../../../openapi");
const field_1 = require("../../../../openapi/field");
const DeviceSchema = __importStar(require("../job/schema"));
const NAMESPACE = 'Culligan.Api.V1.Admin.Device.Schema';
exports.CommandJob = effect_1.Schema.Struct({
    ...DeviceSchema.JobBase.fields,
    command: effect_1.Schema.NonEmptyString,
    params: effect_1.Schema.NullOr(Json.Record),
}).annotations({
    identifier: `${NAMESPACE}.CommandJob`,
});
exports.CommandJobPage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.CommandJob),
    page: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    itemsCount: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    pagesCount: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    provider: effect_1.Schema.optionalWith(openapi_1.Response.ProviderMetadata, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.CommandJobPage`,
});
exports.CommandJobProgress = effect_1.Schema.Struct({
    ...DeviceSchema.JobProgressBase.fields,
    command: effect_1.Schema.NullOr(effect_1.Schema.String),
}).annotations({
    identifier: `${NAMESPACE}.CommandJobProgress`,
});
exports.CommandJobProgressPage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.CommandJobProgress),
    page: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    itemsCount: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    pagesCount: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
    provider: effect_1.Schema.optionalWith(openapi_1.Response.ProviderMetadata, { exact: true }),
}).annotations({
    identifier: `${NAMESPACE}.CommandJobProgressPage`,
});
exports.CommandJobItem = effect_1.Schema.Struct({ item: effect_1.Schema.NullOr(exports.CommandJob) }).annotations({
    identifier: `${NAMESPACE}.CommandJobItem`,
    description: 'item is null when the id belongs to a job of a different kind (e.g. an OTA job).',
});
exports.CommandJobToggleResult = effect_1.Schema.Struct({ item: exports.CommandJob }).annotations({
    identifier: `${NAMESPACE}.CommandJobToggleResult`,
});
exports.UpsertCommandJobPayload = effect_1.Schema.Struct({
    name: effect_1.Schema.NonEmptyString,
    command: effect_1.Schema.NonEmptyString,
    params: effect_1.Schema.optionalWith(Json.Record, { exact: true }),
    enabled: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
    allowLargeRollout: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
    targetSelectionMode: DeviceSchema.TargetSelectionMode,
    deviceGroupId: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }).annotations({
        description: 'Required when targetSelectionMode is deviceGroup.',
    }),
    targetFilterId: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }).annotations({
        description: 'Optional even when targetSelectionMode is filter (unlike the OTA job endpoints): a filter job may be created with neither targetFilterId nor targetFilterParams.',
    }),
    targetFilterParams: effect_1.Schema.optionalWith(Json.Record, { exact: true }).annotations({
        description: 'Inline device search filter.',
    }),
    trigger: effect_1.Schema.optionalWith(DeviceSchema.JobTrigger, { exact: true }),
    targetUpdatePolicy: effect_1.Schema.optionalWith(Job.TargetUpdatePolicy, { exact: true }),
    retryPolicy: effect_1.Schema.optionalWith(Job.RetryPolicy, { exact: true }),
    retryInterval: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.greaterThanOrEqualTo(600)), { exact: true }),
    maxAttempts: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()), { exact: true }),
    startAt: (0, field_1.optionalString)('ISO date-time.'),
    stopAt: (0, field_1.optionalString)('ISO date-time.'),
    notificationTriggers: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.Literal('completed', 'failed')), {
        exact: true,
    }),
}).annotations({
    identifier: `${NAMESPACE}.UpsertCommandJobPayload`,
    description: 'enabled defaults to true, trigger defaults to onDemand.',
});
exports.UpdateCommandJobPayload = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    ...exports.UpsertCommandJobPayload.fields,
}).annotations({
    identifier: `${NAMESPACE}.UpdateCommandJobPayload`,
    description: '404 and CANNOT_EDIT_JOB do not actually trigger: an unknown id creates a new job, and a job in any status is overwritten and reset to queued.',
});
//# sourceMappingURL=schema.js.map